import { render, staticRenderFns } from "./BSJ_A6BD_1D_positioning-modal.vue?vue&type=template&id=16496240&scoped=true"
import script from "./BSJ_A6BD_1D_positioning-modal.vue?vue&type=script&lang=js"
export * from "./BSJ_A6BD_1D_positioning-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16496240",
  null
  
)

export default component.exports